// Declared twice so that docs appear when selecting colors
export interface UltravioletPalette extends Record<string, string> {
  /** **#E3E7F6** Indigo */
  readonly ultraviolet10: string;
  /** **#CBD3F2** Indigo */
  readonly ultraviolet30: string;
  /** **#9EAEE9** Indigo */
  readonly ultraviolet60: string;
  /** **#677CC8** Indigo */
  readonly ultravioletPrimary: string;
  /** **#405AB8** Indigo */
  readonly ultraviolet80: string;
  /** **#0E2579** Indigo */
  readonly ultraviolet90: string;
}

export const ultravioletPalette: UltravioletPalette = {
  ultraviolet10: '#E3E7F6',
  ultraviolet30: '#CBD3F2',
  ultraviolet60: '#9EAEE9',
  ultravioletPrimary: '#677CC8',
  ultraviolet80: '#405AB8',
  ultraviolet90: '#0E2579',
};
